module.exports = __webpack_public_path__ + "media/assets/faria_products/ADV-PLACEMENT-807edcd18f4faa058dc30bb7d71689f5a6ef020ab1896d545c06aa69cd8de7b6.png";